<template>
<div class="solution-content">
  <div class="content">
    <div class="title-name">行业解决方案</div>
    <div class="title-sub">
      橡诺科技有限公司经过多年对客户的经验总结，通过不断的积累，创新，为客户提供各个行业全终端的互联网解决方案。面向全体用户，想客户之所想，做客户之想做
    </div>
    <div class="list">
      <!-- <div > -->
      <router-link class="item" to="/solutionDetails1" target="_blank">
        <div class="name">银行业解决方案</div>
        <div class="pic"><img src="@/assets/img/solution/1.jpg"></div>
      </router-link>
      <!-- </div> -->
      <router-link class="item" to="/solutionDetails2" target="_blank">
        <div class="name">企业金融解决方案</div>
        <div class="pic"><img src="@/assets/img/solution/2.jpg"></div>
      </router-link>
      <router-link class="item" to="/solutionDetails3" target="_blank">
        <div class="name">保险行业解决方案</div>
        <div class="pic"><img src="@/assets/img/solution/3.jpg"></div>
      </router-link>
      <router-link class="item" to="/solutionDetails4" target="_blank">
        <div class="name">地产行业解决方案</div>
        <div class="pic"><img src="@/assets/img/solution/4.jpg"></div>
      </router-link>
      <router-link class="item" to="/solutionDetails5" target="_blank">
        <div class="name">能源行业解决方案</div>
        <div class="pic"><img src="@/assets/img/solution/5.jpg"></div>
      </router-link>
      <router-link class="item" to="/afSolutionDetails" target="_blank">
        <div class="name">汽车金融解决方案</div>
        <div class="pic"><img src="@/assets/img/solution/6.jpg"></div>
      </router-link>
      <router-link class="item" to="/solutionDetails6" target="_blank">
        <div class="name">智能终端测试解决方案</div>
        <div class="pic"><img src="@/assets/img/solution/7.jpg"></div>
      </router-link>
      <router-link class="item" to="/solutionDetails7" target="_blank">
        <div class="name">运营商大数据解决方案</div>
        <div class="pic"><img src="@/assets/img/solution/8.jpg"></div>
      </router-link>
    </div>
    <router-link class="show-more" to="/solution">更多解决方案>></router-link>
  </div>
</div>
</template>

<script>
export default {
  name: ''
}
</script>

<style scoped lang="less">
.solution-content{
  width: 100%;
  height: 737px;
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  .content{
    width: 100%;
    height: 400px;
    overflow: visible;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;
    box-sizing: border-box;
    box-sizing: border-box;
    background-image: url(../assets/img/solution-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .title-name{
      height: 30px;
      color: #FFFFFF;
      transform: .5s;
      line-height: 30px;
      font-size: 30px;
      margin-bottom: 18px;
      box-sizing: border-box;
    }
    .title-sub{
      width: 955px;
      color: #FFFFFF;
      transform: .5s;
      line-height: 24px;
      font-size: 16px;
      text-align: center;
      box-sizing: border-box;
    }
    .list{
      margin-top: 35px;
      margin-bottom: 30px;
      width: 1200px;
      display: -webkit-flex;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      box-sizing: border-box;
      .item{
        position: relative;
        width: 300px;
        overflow: visible;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        .name{
          position: absolute;
          width: 100%;
          top: 0;
          bottom: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #FFFFFF;
          transform: .5s;
          font-size: 28px;
          text-align: center;
          background-color: RGBA(0,0,0,0.3);
          box-sizing: border-box;
        }
        .pic{
          img{
            width: 100%;
            vertical-align: middle;
          }
        }
      }
    }
  }
  
}
</style>
